import { render } from "./HeroComp.vue?vue&type=template&id=45be7d4d&scoped=true"
import script from "./HeroComp.vue?vue&type=script&lang=js"
export * from "./HeroComp.vue?vue&type=script&lang=js"

import "./HeroComp.vue?vue&type=style&index=0&id=45be7d4d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\LENOVO\\Documents\\workspace\\tulumoutdoor_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45be7d4d"]])

export default __exports__